import { render } from "./localization.vue?vue&type=template&id=41772073"
import script from "./localization.vue?vue&type=script&lang=ts"
export * from "./localization.vue?vue&type=script&lang=ts"
script.render = render

export default script